<template>
  <v-data-table
    :headers="headers"
    :items="teams"
    sort-by="model"
    class="elevation-1 dark-last-row"
    hide-default-footer
    :loading="loading"
    items-per-page="500"
    mobile-breakpoint="0"
    :expanded.sync="expanded"
    show-expand
    single-expand
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="#003a6f"
      >
        <v-toolbar-title class="white--text">Teams</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialogPhase"
          max-width="500px"
          scrollable
        >
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">Edit Phase</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row"> 
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Job</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Job" rules="required">
                            <v-autocomplete
                                v-model="editedJob"
                                :items="jobs"
                                item-text="customer"
                                item-value="id"
                                label="Job"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                                return-object
                            ></v-autocomplete>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedJob.id">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Phase</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Phase" rules="required">
                              <v-select
                                  v-model="editedJob.phase"
                                  :items="editedJob.phases"
                                  item-text="title"
                                  item-value="id"
                                  label="Phase"
                                  :error-messages="errors"
                                  required
                                  solo
                                  flat
                                  dark
                              ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedJob.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Start Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu
                                v-model="menus"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedStartDateFormatted"
                                    label="Start Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    flat
                                    dark
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="editedJob.start_date"
                                @input="menus = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedJob.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">End Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu
                              v-model="menue"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="computedEndDateFormatted"
                                  label="End Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  solo
                                  flat
                                  dark
                              ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="editedJob.end_date"
                              @input="menue = false"
                              ></v-date-picker>
                          </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedJob.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                              <v-select
                                  v-model="editedJob.status"
                                  :items="statuses"
                                  item-text="label"
                                  item-value="value"
                                  label="Status"
                                  :error-messages="errors"
                                  required
                                  solo
                                  flat
                                  dark
                              ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row" v-if="editedJob.phase">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Description</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-textarea
                              v-model="editedJob.description"
                              label="Description"
                              required
                              solo
                              flat
                              dark
                            ></v-textarea>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="closePhase"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="savePhase"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="green"
              dark
              tile
              small
              to="/team_history"
            >
              <v-icon dark>mdi-calendar</v-icon>
              Team History
            </v-btn>
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="#004889">
            <v-card-title class="accent">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="warrantyform">
                  <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Title</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Title" rules="required">
                              <v-text-field
                                v-model="editedItem.title"
                                label="Title"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Team Category" rules="required">
                            <v-select
                                v-model="editedItem.category"
                                :items="categories"
                                item-text="label"
                                item-value="value"
                                label="Team Category"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                            ></v-select>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Notification No</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-text-field
                                v-model="editedItem.notification_no"
                                label="Notification No"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text text-center">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogComplete" max-width="500px">
          <v-card color="green">
            <v-card-title class="subtitle-2 justify-center white--text text-center">Are you sure you want to complete this item?</v-card-title>
            <v-card-actions class="green darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="white darken-1" text @click="closeComplete">Cancel</v-btn>
              <v-btn tile color="green--text" @click="completeItemConfirm" :loading="loading">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getEquipment"
        tile
        :loading="loading"
      >
        No Items Found. Click Here to Refresh!
      </v-btn>
    </template>
    <template v-slot:item.phase="{ item }">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
                v-for="(job, index) in item.jobs"
                :key="`pt-${index}`"
              >
                <td class="caption px-1" width="45%"><a href="#" @click.prevent="editPhase(item, job)">{{ getPhaseTitle(job) }}</td>
                <td class="caption px-1" width="45%">
                  <router-link :to="`/job/main/${job.id}`">
                      {{ job.customer }}
                  </router-link>
                </td>
                <td width="10%" class="px-0">
                  <v-icon
                    dark
                    right
                    color="green"
                    @click="completeItem(job)"
                  >
                    mdi-checkbox-marked-circle
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <span class="d-flex justify-center">
          <v-btn
            tile
            text
            small
            @click="assignPhase(item)"
          >
          <v-icon left>
            mdi-plus
          </v-icon>
            Assign
          </v-btn>
        </span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-0 button-row">
        <v-btn large min-width="33.33%" color="green" dark tile @click="openCalendar(item)" class="elevation-0">      
            <v-icon
            >
            mdi-calendar
            </v-icon>
        </v-btn>     
        <v-btn large min-width="33.33%" color="primary" tile @click="editItem(item)" class="elevation-0">      
            <v-icon
            >
            mdi-pencil
            </v-icon>
        </v-btn>             
        <v-btn large min-width="33.33%" color="red" tile @click="deleteItem(item.id)" class="elevation-0">
            <v-icon
            color="white"
            >
            mdi-delete
            </v-icon>  
        </v-btn>  
      </td>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import mixin from '../../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            dialogPhase: false,
            menu: false,
            headers: [
                { text: 'Crew', value: 'title', sortable: false, width: '25%' },
                { text: 'Phase/Customer', value: 'phase', sortable: false, width: '65%' },
                { text: '', value: 'data-table-expand', width: '10%'  },
            ],
            teams: [],
            jobs: [],
            phases: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                title: '',
                category: '',
                notification_no: '',
                job: {
                  id: '',
                  phase: '',
                  customer: '',
                  title: '',
                  start_date: new Date().toISOString().substr(0, 10),
                  end_date: new Date().toISOString().substr(0, 10),
                  status: 'in_progress',
                  description: ''
                }
            },
            editedJob: {
              id: '',
              phase: '',
              customer: '',
              title: '',
              start_date: new Date().toISOString().substr(0, 10),
              end_date: new Date().toISOString().substr(0, 10),
              status: 'in_progress',
              description: ''
            },
            defaultJob: {
              id: '',
              phase: '',
              customer: '',
              title: '',
              start_date: new Date().toISOString().substr(0, 10),
              end_date: new Date().toISOString().substr(0, 10),
              status: 'in_progress',
              description: ''
            },
            defaultItem: {
                id: '',
                title: '',
                category: '',  
                notification_no: '',
                job: {
                  id: '',
                  phase: '',
                  customer: '',
                  title: '',
                  start_date: new Date().toISOString().substr(0, 10),
                  end_date: new Date().toISOString().substr(0, 10),
                  status: 'in_progress',
                  description: ''
                }             
            },
            categories: [
              { label: 'Dig Team', value: 1 },
              { label: 'Concrete Crew', value: 2 },
              { label: 'Liner Crew', value: 3 },
              { label: 'Grade Crew', value: 4 },
              { label: 'Finish up Crew', value: 5 },
            ],
            expanded: [],
            statuses: [
                { label: 'Completed', value: 'completed' },
                { label: 'In Progress', value: 'in_progress' },
                { label: 'Pending', value: 'pending' },
                { label: 'Cancelled', value: 'cancelled' },
            ],
        }),

        components: {
            ValidationProvider,
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Team' : 'Edit Team'
            },
            computedStartDateFormatted () {
              if(this.editedJob)
                return this.formatDate(this.editedJob.start_date)
              else 
                return ''
            },
            computedEndDateFormatted () {
              if(this.editedJob)
                return this.formatDate(this.editedJob.end_date)
              else
                return ''
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            'editedItem.phase': function(newVal) {
              let phase = this.jobs.filter(p => {
                return p.id == newVal
              })

              this.editedItem.job = phase[0]
            }
        },

        created () {
            this.getTeams()
        },

        methods: {
            getTeams() {
                this.loading = true
                axios.get('crm/teams/get')
                    .then(response => {
                        this.loading = false
                        this.teams = response.data.teamlist
                        this.jobs = response.data.jobslist
                        this.phases = response.data.phaselist
                        this.$nextTick()
                    })
            },

            editItem (item) {
                this.editedIndex = this.teams.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (id) {
                this.editedIndex = id
                this.dialogDelete = true
            },

            completeItem (job) {
                this.editedJob = job
                this.dialogComplete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('crm/team/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getPhases()
                      this.$nextTick()
                    })
            },

            completeItemConfirm () {
                this.loading = true
                axios.post('crm/team/job/phase/complete', {
                    job: this.editedJob,
                }).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.getTeams()
                    this.closeComplete()
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedJob= Object.assign({}, this.defaultJob)
                  this.editedIndex = -1
                  this.errors.clear()
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedJob= Object.assign({}, this.defaultJob)
                  this.editedIndex = -1
                })
            },

            closeComplete () {
                this.dialogComplete = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedJob= Object.assign({}, this.defaultJob)
                  this.editedIndex = -1
                })
            },

            openCalendar(item) {
                this.$router.push('/team_calendar/' + item.id)
            },

            assignPhase (item) {
                this.editedIndex = this.teams.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogPhase = true
            },

            editPhase (item, job) {
                this.editedIndex = this.teams.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.editedJob = job
                this.dialogPhase = true
            },

            closePhase () {
                this.dialogPhase = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedJob= Object.assign({}, this.defaultJob)
                  this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/team/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getTeams()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('crm/team/add', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getTeams()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },

            async savePhase () {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    axios.post('crm/team/job/update', {
                        id: this.editedJob.phase,
                        job_id: this.editedJob.id,
                        team_id: this.editedItem.id,
                        start_date: this.editedJob.start_date,
                        end_date: this.editedJob.end_date,
                        status: this.editedJob.status,
                        description: this.editedJob.description
                    }).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.getTeams()
                        this.closePhase()
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },

            getCategory(id) {
              let categories = this.categories.filter(cat => {
                return cat.value == id
              })

              return categories[0].label
            },

            getPhaseTitle(job) {
                if(job) {
                  let phase = this.phases.filter(i => {
                    return i.id == job.phase
                  })

                  if(phase.length) 
                    return phase[0].title
                  else 
                    return ''
                }
            },
        },
    }
</script>

<style lang="sass">
.button-row 
    height: auto!important

thead
    &.v-data-table-header
        background: #2196F3

        th 
            span
                font-size: 16px
                color: #ffffff
                line-height: 1em
</style>